import React from 'react';
import T from 'prop-types';

const StateCheckInbox = ({ email, error, onResendClick }) => (
  <div className="press-register-status press-register-status--info">
    <div className="press-register-status__icon press-register-status__icon--info">
      <i className="hicon-check-thin" />
    </div>
    <h1 className="press-register-status__title">Check your inbox</h1>
    <p className="press-register-status__subtitle">
      We sent a login link to {email}. Click the link in that email to sign in — it expires in 15
      minutes.
    </p>
    <div className="press-register-status__info">
      Didn’t receive the link? Check your spam folder, or{' '}
      <a href="#" className="text-bold" aria-disabled={!!error} onClick={onResendClick}>
        resend the link
      </a>
      .
    </div>
  </div>
);

StateCheckInbox.propTypes = {
  email: T.string,
  error: T.string,
  onResendClick: T.func,
};

StateCheckInbox.defaultProps = {
  email: '',
  error: '',
  onResendClick: () => {},
};

export default StateCheckInbox;
